<template>
    <div class="bg-white shadow-sm border">
        <div class="container d-flex">
            <div class="col-3 border-left py-1">
                <div class="text-sm text-muted">
                    {{ $t('airport_transfers.components.search_form.from') }}:
                </div>

                <div class="text-black">
                    {{ searchData.start_place_name }}
                </div>
            </div>

            <div class="col-3 border-left py-1">
                <div class="text-sm">
                    {{ $t('airport_transfers.components.search_form.to') }}:
                </div>

                <div class="text-black">
                    {{ searchData.end_place_name }}
                </div>
            </div>

            <div class="col border-left py-1">
                <div class="text-sm">
                    {{ $t('departure_date') }}:
                </div>

                <div class="text-black">
                    {{ searchData.departure_date }}
                </div>
            </div>
            <div class="col border-left py-1" v-if="searchData.return_date">
                <div class="text-sm">
                    {{ $t('return_date') }}:
                </div>
                <div class="text-black">
                    {{ searchData.return_date }}
                </div>
            </div>

            <div class="col border-left py-1">
                <div class="text-sm text-black-50">
                    {{ $t('passengers') }}:
                </div>

                <div class="text-black text-sm">
                    {{ searchData.passengers_number }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    export default {
        computed: {
            ...mapGetters({
                searchData: 'airportTransfersSearch/getSearchParameters',
            }),
        },
    };
</script>
